import { defineStore } from 'pinia';
import type { Channel } from '@getaccept/pusher';
import { ChannelType } from '@getaccept/pusher';
import type { Conversation } from '@getaccept/dsr-shared';
import { pusherClient } from '../../api/pusher/pusher-client';
import type { PusherState } from '../types/pusher-state';

export const usePusherStore = defineStore('pusher', {
  state: (): PusherState => ({
    channels: { conversations: {} },
  }),
  actions: {
    async setConversationChannels(conversations: Conversation[]) {
      for (const conversation of conversations) {
        const existingChannel: Channel = this.channels.conversations[conversation.id];
        if (!existingChannel) {
          const newChannel: Channel = await pusherClient.subscribe(
            ChannelType.Conversation,
            conversation.id
          );
          this.channels.conversations = {
            ...this.channels.conversations,
            [conversation.id]: newChannel,
          };
        }
      }
    },
  },
});
